import { setSearchTerm } from "../citiesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useCitySearch = () => useSearch(s => s.data.listing.cities.searchTerm, setSearchTerm);
